"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Headline_1 = require("../../atoms/Headline");

var Headline_2 = require("../../atoms/Headline/Headline");

exports.TextSection = function (_a) {
  var id = _a.id,
      className = _a.className,
      children = _a.children,
      label = _a.label,
      title = _a.title,
      titleSize = _a.titleSize,
      signal = _a.signal;
  var textSectionProps = {
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "text-section", className]),
    id: id
  };
  var headlineId = id ? id + "-headline" : undefined;
  var contentId = id ? id + "-content" : undefined;
  return React.createElement("article", __assign({}, textSectionProps), React.createElement(Headline_1.Headline, {
    size: titleSize || Headline_1.Headline.Sizes.H2,
    className: CSSPrefix_1.lsgPre + "text-section-title",
    id: headlineId
  }, title), React.createElement("div", null, label && React.createElement("label", {
    className: CSSPrefix_1.lsgPre + "text-section-label"
  }, label), signal && React.createElement("span", {
    className: CSSPrefix_1.lsgPre + "text-section-signal"
  }, signal)), React.createElement("div", {
    className: CSSPrefix_1.lsgPre + "text-section-content",
    id: contentId
  }, children));
};

exports.TextSection.Sizes = Headline_2.Sizes;
exports.TextSection.displayName = "TextSection";